export default __webpack_public_path__ + "static/media/uac-shield.e7aafc83.png";